var React = require('react');

function CreditCard (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"credit-card","d":"M3.231,6H26.615a1.231,1.231,0,0,1,1.231,1.231V20.769A1.231,1.231,0,0,1,26.615,22H3.231A1.231,1.231,0,0,1,2,20.769V7.231A1.231,1.231,0,0,1,3.231,6ZM20.871,18.168a2.462,2.462,0,1,0,0-4.643,3.693,3.693,0,0,1,0,4.643ZM18,18.308a2.462,2.462,0,1,0-2.462-2.462A2.462,2.462,0,0,0,18,18.308ZM5.077,9.692a.615.615,0,0,0,0,1.231h6.154a.615.615,0,1,0,0-1.231Zm0,2.462a.615.615,0,1,0,0,1.231H8.769a.615.615,0,0,0,0-1.231Z","transform":"translate(-2 -6)","fill":"#2425aa","fillRule":"evenodd"}));
}

CreditCard.defaultProps = {"width":"25.846","height":"16","viewBox":"0 0 25.846 16"};

module.exports = CreditCard;

CreditCard.default = CreditCard;
